import { render, staticRenderFns } from "./SubBtn.vue?vue&type=template&id=5bb9f276"
import script from "./SubBtn.vue?vue&type=script&lang=js"
export * from "./SubBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports